import React, {createRef, Fragment, useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import __ from "lodash";
import { Grid } from "@material-ui/core";

import {FormDialog, FormSelect, ComboSelect, Text} from "../../../controls";
//import ScheduledTripLegEditor from "./ScheduledTripLegEditor";
import Validator from "../validators/AddCostingValidator";
import useTripDepartmentUsers from "../../../services/auth/useTripDepartmentUsers";
import { useCostCategories } from '../../../services/costings';

import AircraftLookup from '../../Aircraft/components/AircraftLookup';
import BuildPrimaryRouteFromLegs from '../../Trips/utils/BuildPrimaryRouteFromLegs';
import BuildOnwardRoutesFromLegs from '../../Trips/utils/BuildOnwardRoutesFromLegs';
import BuildTruckRoutesFromLegs from '../../Trips/utils/BuildTruckRoutesFromLegs';
import CostingSectorsEditor from './CostingSectorsEditor';
import {fetch as fetchCargo} from '../../../services/costings/useCostingCargo';
import {fetch as fetchSectors} from '../../../services/costings/useCostingSectors';
import {fetch as fetchServices} from '../../../services/costings/useCostingServices';
import {fetch as fetchCommissions} from '../../../services/costings/useCostingCommissions';
import FlightCostsView from './FlightCostsView';
import CostingCargoEditor from './CostingCargoEditor';
import CostingGroundEditor from './CostingGroundEditor';
import CostingRevenueEditor from './CostingRevenueEditor';
import CostingOtherSectorsEditor from './CostingOtherSectorsEditor';
import CostingTotals from './CostingTotals';
import { useSettings } from '../../../services/settings';
import CostingCommissionEditor from './CostingCommissionEditor';

const emptyCosting = {
//  costingDate: moment.utc().toISOString(),
  routeWinds: process.env.REACT_APP_DEFAULT_WINDCODE || 'GRIB-UKO-WX', 
  routeWindsMonth: "",
  legs:[],
  cargo: [],
  services: [],
  commissions: [],
  weightUom: "KG"
}

const ViewCostingDialog = (props) => {
  const {SystemData, extraKeys, handleUpdate, classes, defaultValues} = props;
  const eventBus = SystemData.eventBus;
  const ownerDepartment = defaultValues?.ownerDepartment||'COMMERCIAL';

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: __.cloneDeep(emptyCosting),
    title: 'View Costing'
  });

  const formId = 'ViewCosting';

  const dateFormat = "DD/MM/YYYY";

  const queryClient = useQueryClient();
  const departmentUsers = useTripDepartmentUsers({queryClient, extraKeys: [ownerDepartment]});
  const costCategories = useCostCategories({queryClient, extraKeys: [], params: {level: "COSTING", includeGroup: 1}})
  const costingErrors = useSettings({queryClient, extraKeys: ["COSTING ERRORS"], useCache: true});

  useEffect(()=> {
    const open = async (record) => {
      const {costingUuid, costingNumber} = record;
      const title = `View Costing UCN-${costingNumber}`;
      Promise.all([
        fetchCargo({queryClient, extraKeys: [costingUuid]}),
        fetchSectors({queryClient, extraKeys: [costingUuid]}),
        fetchServices({queryClient, extraKeys: [costingUuid]}),
        fetchCommissions({queryClient, extraKeys: [costingUuid]})
      ]).then(([cargo, legs, services, commissions]) => {
        record['cargo'] = cargo;
        record['legs'] = legs;
        record['services'] = services;
        record['commissions'] = commissions;
        setDialogStates(
          {
            ...dialogStates,
            showDialog:true,
            title,
            record,
          }
        );  
      });
    }

    const close = () => {
      setDialogStates({...dialogStates, showDialog:false, record: __.cloneDeep(emptyCosting), title: 'View Costing'});
    }
    
    eventBus.bind("ViewCostingDialog.open", open);
    eventBus.bind("ViewCostingDialog.close", close);

    return () => {
      eventBus.unbind("ViewCostingDialog.open", open);
      eventBus.unbind("ViewCostingDialog.close", close);
    }
  }, [dialogStates, eventBus, queryClient, SystemData]);

  const userOptions = departmentUsers.data?departmentUsers.data.map((userOption, i) => {
    return {code: userOption.user_id, value: `${userOption.firstName} ${userOption.lastName}`};
  }).sort((u1, u2) => {
    if (u1.value === u2.value) return 0;
    if (u1.value < u2.value) return -1;
    return 1;
  }):null;

  const getAccountManager = (user_id) => {
    if (!departmentUsers?.data) return '';
    const userOption = __.find(departmentUsers.data, {user_id});
    if (!userOption) return '';
    return `${userOption.firstName} ${userOption.lastName}`;
  }

  if (dialogStates.showDialog && departmentUsers?.data && costCategories?.data && costingErrors?.data) {
    return (
      <>
        <FormDialog
          formId={formId}
          title={dialogStates.title}
          message=""
          open={dialogStates.showDialog}
          record={dialogStates.record}
          dialogOptions={{maxWidth: "lg", fullWidth: true}}
          classes={classes}
          validator={Validator}
          buttons = {{
            cancel:{icon: "cancel", key: "Close", label: "Close", color: "primary"}
          }}
          onChange={(state) => {
            setDialogStates({...dialogStates, showDialog: false, record: null});
          }}

        >
          <Grid container checkChildren={true} spacing={3}>
            {/* <Grid item xs={1} checkChildren={true}>
              <MaskedText
                id="uniqueCostingNo"
                label="Costing Number"
                style={{width: "100%"}}
                mask="UUU-9999999"
                maskChar={""}
                alwaysShowMask={false}
                forceUpperCase={true}
                defaultValue=""
                inputLabelProps={{shrink: true}}
                onChange={(value, props) => {
                  const requestNo = ++requestRef.current;
                  axios.get(
                    `${apiSitePrefix}/mcsdata/costingexists/${value}/___`
                  ).then(costingExists => {
                    if (requestNo === requestRef.current) {
                      if (costingExists.data) {
                        props.recordChange({tripRoute: costingExists.data.routing, uniqueCostingNo: value});
                      }
                    }
                  });
                  props.onChange(value);
                }}
              />
            </Grid> */}
            <Grid item xs={2} checkChildren={true}>
              {(record) => (
                <Fragment checkChildren={false}>
                  <Text
                    id="aircraftReg"
                    label="Aircraft"
                    value={record.aircraftReg}
                    inputLabelProps={{shrink: true}}
                    style={{paddingLeft: 0}}
                  />
                </Fragment>
              )}
            </Grid>
            <Grid item xs={2} checkChildren={true} style={{marginTop: 1}}>
              {record =>
                <Fragment checkChildren={false}>
                  <Text
                    id="commercialOwnerId"
                    label="Account Manager"
                    value={getAccountManager(record.commercialOwnerId)}
                    style={{width: 200}}
                  />
                </Fragment>
              }
            </Grid>
            <Grid item xs={2} checkChildren={true} style={{marginTop: 1}}>
            {record =>
              <ComboSelect
                id="routeWinds"
                label="Route Wind"
                group='COSTING'
                subGroup='ROUTE WIND'
                returnType="value"
                inputLabelProps={{shrink: true}}
                displayOnly={true}
              />
            }
            </Grid>
            <Grid item xs={2} checkChildren={true} style={{marginTop: 1}}>
            {record =>
              <ComboSelect
                id="routeWindsMonth"
                label="Historical Month"
                group='MONTHS'
                subGroup='NUMBER'
                returnType="value"
                inputLabelProps={{shrink: true}}
                disabled={record.routeWinds !== "HISTORICAL-WX"}
                displayOnly={true}
              />
            }
            </Grid>
            <Grid item xs={2} checkChildren={true} style={{marginTop: 1}}>
            {record =>
              <ComboSelect
                id="revenueCalculationMethod"
                label="Revenue Model"
                group='COSTING REVENUE METHODS'
                subGroup=''
                returnType="value"
                inputLabelProps={{shrink: true}}
                displayOnly={true}
              />
            }
            </Grid>
          </Grid>
          <Grid container checkChildren={true} spacing={3}>
            <Grid item xs={3} checkChildren={true}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="primaryRoute" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Route
                </label>
              </div>
              <div id="primaryRoute" style={{paddingTop: 6}}>
                {(rowData) => (<BuildPrimaryRouteFromLegs legs={rowData.legs}/>)}
              </div>
            </Grid>
            <Grid item xs={2} checkChildren={true}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="onwardRoutes" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Onward Routes
                </label>
              </div>
              <div id="onwardRoutes" style={{paddingTop: 6}}>
                {(rowData) => (<BuildOnwardRoutesFromLegs legs={rowData.legs}/>)}
              </div>
            </Grid>
            <Grid item xs={2} checkChildren={true}>
            <div className="d-flex flex-row justify-content-between align-items-center">
                <label htmlFor="truckRoutes" className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-animated MuiInputLabel-shrink">
                  Trucking
                </label>
              </div>
              <div id="truckRoutes" style={{paddingTop: 6}}>
                {(rowData) => (<BuildTruckRoutesFromLegs legs={rowData.legs}/>)}
              </div>
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              <div>
                {(record) => (
                  <CostingCargoEditor
                    record={record}
                    // handleUpdate={handleUpdate}
                    extraKeys={extraKeys}
                    canEdit={false}
                    classes={classes}
                    defaultValues={defaultValues}
                    weightUom={record.weightUom}
                    readOnly={true}
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              <div>
                {(record) => (
                  <CostingSectorsEditor
                    record={record}
                    handleUpdate={handleUpdate}
                    extraKeys={extraKeys}
                    canEdit={false}
                    classes={classes}
                    defaultValues={defaultValues}
                    weightUom={record.weightUom}
                    readOnly={true}
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              <div>
                {(record) => (
                  <CostingOtherSectorsEditor
                    record={record}
                    handleUpdate={handleUpdate}
                    extraKeys={extraKeys}
                    canEdit={false}
                    classes={classes}
                    defaultValues={defaultValues}
                    weightUom={record.weightUom}
                    readOnly={true}
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              {(record) => (
                <FlightCostsView
                  record={record}
                  classes={classes}
                  defaultValues={defaultValues}
                  weightUom={record.weightUom}
                  readOnly={true}
                />
              )}
            </Grid>          
            <Grid item xs={12} checkChildren={true}>
              {(record) => (
                <CostingGroundEditor
                  record={record}
                  eventBus={eventBus}
                  systemData={SystemData}
                  canEdit={false}
                  classes={classes}
                  defaultValues={defaultValues}
                  rebuildRunning={false}
                  readOnly={true}
                />
              )}
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              {(record) => (
                <CostingCommissionEditor
                  record={record}
                  eventBus={eventBus}
                  systemData={SystemData}
                  canEdit={false}
                  classes={classes}
                  defaultValues={defaultValues}
                  costingErrors={costingErrors}
                />
              )}
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              {(record) => (
                <CostingRevenueEditor
                  record={record}
                  eventBus={eventBus}
                  systemData={SystemData}
                  canEdit={false}
                  classes={classes}
                  defaultValues={defaultValues}
                  rebuildRunning={false}
                  readOnly={true}
                />
              )}
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              {(record) => (
                <CostingTotals
                  record={record}
                  eventBus={eventBus}
                  systemData={SystemData}
                  canEdit={false}
                  classes={classes}
                  defaultValues={defaultValues}
                  rebuildRunning={false}
                  costingErrors={costingErrors}
                  readOnly={true}
                />
              )}
            </Grid>
          </Grid>
        </FormDialog>
      </>
    )
  }
  return (<></>);
}

export default ViewCostingDialog;
